import type { CarouselFeature } from '@indutrust/shared-model';

export const carouselFeatureList: CarouselFeature[] = [
  {
    id: 'decisionMaking',
    title: 'features.decisionMaking.title',
    description: 'features.decisionMaking.description',
    coverType: 'image',
    coverImage: 'assets/images/features-carousel/screen-filters-2.png',
    tags: ['1', '2', '3', '4'],
  },
  {
    id: 'supplierCV',
    title: 'features.supplierCV.title',
    description: 'features.supplierCV.description',
    coverType: 'image',
    coverImage: 'assets/images/features-carousel/screen-supplier-2.png',
    tags: ['1', '2', '3', '4'],
  },
  {
    id: 'virtualTour',
    title: 'features.virtualTour.title',
    description: 'features.virtualTour.description',
    coverType: 'image',
    coverImage: 'assets/images/features-carousel/screen-vr-2.png',
    tags: ['1', '2', '3', '4'],
  },
  {
    id: 'vision',
    title: 'features.vision.title',
    description: 'features.vision.description',
    coverType: 'vision',
    coverVisions: [
      'assets/images/features-carousel/vision/vision-emirates.png',
      // 'assets/images/features-carousel/vision/vision-saudi.png',
      // 'assets/images/features-carousel/vision/vision-qatar.png',
      // 'assets/images/features-carousel/vision/vision-oman.png',
      // 'assets/images/features-carousel/vision/vision-kuwait.png',
      // 'assets/images/features-carousel/vision/vision-bahrain.png',
    ],
    tags: ['1', '2', '3', '4'],
  },
];
